import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { ControlContainer, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { YesNoQuestion } from 'src/app/bo/customer-feedback/yes-no-question';

@Component({
  selector: 'app-yes-no-question',
  templateUrl: './yes-no-question.component.html',
  styleUrls: ['./yes-no-question.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ReactiveFormsModule, TranslateModule]
})
export class YesNoQuestionComponent implements OnInit {
  @Input() form!: FormGroup;
  @Input() question: YesNoQuestion;

  switchLabel = 'No';
  constructor(private readonly controlContainer: ControlContainer, private readonly translate: TranslateService
  ) { }
  ngOnInit(): void {
    this.form = this.controlContainer.control as FormGroup;
    this.switchLabel = this.form.controls[this.question.uniqueId]?.value ? this.translate.instant('GLOBAL.OUI') : this.translate.instant('GLOBAL.NON');

   this.form.controls[this.question.uniqueId]?.valueChanges.subscribe((value: boolean) => {
     this.switchLabel = value ? this.translate.instant('GLOBAL.OUI') : this.translate.instant('GLOBAL.NON');
   });
  }
  updateLabel() {
    this.switchLabel = this.form.controls[this.question.uniqueId]?.value ? this.translate.instant('GLOBAL.OUI') : this.translate.instant('GLOBAL.NON');
  }
}
